import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { keyframes } from '@mui/system';
import { RUCHI_VEDIKA_LOGO } from '../../constants';

// The breathing pulse for the logo
const logoPulse = keyframes`
  0% { transform: scale(0.95); opacity: 0.9; }
  50% { transform: scale(1); opacity: 1; }
  100% { transform: scale(0.95); opacity: 0.9; }
`;

// The expanding aura ripples
const ripple = keyframes`
  0% { transform: scale(1); opacity: 0.5; }
  100% { transform: scale(2.5); opacity: 0; }
`;

const MaskLoader = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // Darker, more sophisticated glass effect
                backgroundColor: 'rgba(10, 10, 10, 0.7)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                zIndex: 9999,
            }}
        >
            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                
                {/* Triple Ripple Effect */}
                {[...Array(3)].map((_, i) => (
                    <Box
                        key={i}
                        sx={{
                            position: 'absolute',
                            width: 80,
                            height: 80,
                            borderRadius: '50%',
                            border: `1.5px solid ${theme.palette.primary.main}`,
                            animation: `${ripple} 3s infinite ease-out`,
                            animationDelay: `${i * 1}s`, // Staggered ripples
                        }}
                    />
                ))}

                {/* Central Logo Container */}
                <Box
                    sx={{
                        position: 'relative',
                        width: 100,
                        height: 100,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: theme.palette.common.black,
                        borderRadius: '24px', // Modern rounded corners
                        boxShadow: `0 0 30px ${theme.palette.primary.main}40`,
                        border: `1px solid rgba(222, 212, 24, 0.1)`,
                        zIndex: 2,
                        animation: `${logoPulse} 2s infinite ease-in-out`,
                    }}
                >
                    <Box
                        component="img"
                        src={RUCHI_VEDIKA_LOGO}
                        alt="Loading"
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }}
                    />
                </Box>
            </Box>

            {/* Premium Progress Text */}
            <Box sx={{ mt: 6, textAlign: 'center' }}>
                <Typography
                    variant="h6"
                    sx={{
                        color: '#fff',
                        fontWeight: 300,
                        letterSpacing: '0.2em',
                        textTransform: 'uppercase',
                        fontSize: '0.75rem',
                        opacity: 0.6
                    }}
                >
                    Express Fast
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: theme.palette.primary.main,
                        fontWeight: 600,
                        mt: 0.5,
                        letterSpacing: '0.1em'
                    }}
                >
                    STAY TUNED...
                </Typography>
            </Box>
        </Box>
    );
};

export { MaskLoader };